import { render, staticRenderFns } from "./vueLocalBlock.vue?vue&type=template&id=945fc990&scoped=true"
import script from "./vueLocalBlock.vue?vue&type=script&lang=js"
export * from "./vueLocalBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945fc990",
  null
  
)

export default component.exports